export default __webpack_public_path__ + "static/Cascale_FullColor_Positive-fd00ab73ecbc7b2e8374637fa4d0e589.png";